// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"go-z","breadcrumbForward":"ho-z","breadcrumbBack":"io-z","selected":"jo-z"};